<template>
    <ListaUsuarios class="container mx-auto margin-b text-center" />
</template>

<script>
//Componentes
import ListaUsuarios from '../components/ListaUsuarios.vue';

export default {
  components: {
    ListaUsuarios
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style>
  .margin-b {
    margin-bottom: 5rem;;
  }
</style>